jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');

	var polyfillMultiselects = function () {
		$('select[multiple]').multiselect().on('focus blur reset', function (e) {
			$(this).parents('.pagecreator_formelement').eq(0).css('z-index', e.type === 'focus' ? 8 : '');

			if (e.type === 'reset') {
				$(this).next().find('.active').removeClass('active');
				setTimeout(function () {
					$(this).val('');
				}.bind(this), 10);
			}
		});
	};
	polyfillMultiselects();

	$html.on({
		ready: function() {
			polyfillPlaceholders();
			polyfillMultiselects();
		}
	}, '.pagecreator_filter');

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	/**
	 * Tabs for Posttypelist
	 */

	$('.posttypelist_tabs').on({
		change: function () {
			if($(this).is('select') ? true : $(this).is(':checked')) {
				var $list = $(this).parents('.posttypelist_tabs'),
					$article = $list.find(this.value);

				$list.find('.type-tab').hide();
				$article.show();
			}
		}
	}, '.posttypelist_tabs__switcher-item')
		.find('.posttypelist_tabs__switcher-item').eq(0).attr('checked', true).change();

	/**
	 * Tabs for Posttypelist
	 */

	$(document).ajaxComplete(function() {
		$.ajaxSetup({
			beforeSend: function(jqXHR, settings) {}
		});
	});

	$('.posttypelist_tabs').on({
		mousedown: function() {
			var tab_id = $(this).parents('.type-tab').attr('id').split('-')[1];

			$.ajaxSetup({
				beforeSend: function(jqXHR, settings) {
					settings.url = settings.url.replace(/post_id=[0-9]+&/g, 'post_id=' + tab_id + '&');
				}
			});
		}
	}, '.type-tab .page-link');




	/**
	 * Classes for Animation
	 */

	$('.article, .slide, .pagecreator_wysiwygeditor').one('inview', function () {
		$(this).addClass("is-inview");
	});


	/**
	 * Hamburger Toggle
	 */

	var links = document.querySelectorAll('.navigation .menu-item a');
	var linksLength = links.length

	for(var i = 0; i < linksLength; i++) {
		links[i].addEventListener('click', function() {
			document.getElementById('hamburgerToggle').checked = false;
		});
	}


	/**
	 * Delete Filter tags
	 */
	$html.tagsHandler();

	/**
	 * Fix reset button for ajax filters
	 */
	$html.on({
		click: function () {
			var $form = $(this).parents('form')

			$form.find('input:not([type="submit"]), select, textarea').each(function () {
				console.log(this.type.toLowerCase())
				switch (this.type.toLowerCase()) {
					case 'text':
					case 'password':
					case 'textarea':
					case 'hidden':
						$(this).val('')
						break
					case 'radio':
						$(this).attr('checked', false)
						$('[name="' + $(this).attr('name') + '"]').eq(0).attr('checked', true)
						break
					case 'checkbox':
						$(this).attr('checked', false)
						break
					case 'select-one':
					case 'select-multi':
						$(this).find('options').removeAttr('selected')
						this.selectedIndex = 0
						break
				}
			})
			$form.trigger('submit')
		}
	}, 'form[data-fetch="1"] [type="reset"]');

	if(window.location.hash.match('contact-[0-9]+')) {
		setTimeout(function() {
			jQuery(document).scrollTop(jQuery(window.location.hash).offset().top - jQuery('.container-header').height());
			jQuery(window.location.hash).css({
				outline: '3px solid #ffcc00'
			});
		}, 2000);
	}
});
